// Centralized SEO configuration — single source of truth for static-page metadata
// and the keyword map. Service/city/post metadata lives alongside its content in
// src/data/services.js, src/data/locations.js, and src/data/blog/*.

export const KEYWORD_MAP = {
  '/': 'outdoor living Omaha NE',
  '/services/': 'outdoor living services Omaha NE',
  '/services/outdoor-kitchens/': 'outdoor kitchens Omaha NE',
  '/services/sunrooms/': 'sunrooms Omaha NE',
  '/services/patio-enclosures/': 'patio enclosures Omaha NE',
  '/services/decks/': 'deck building Omaha NE',
  '/services/pergolas/': 'pergolas Omaha NE',
  '/services/water-features/': 'water features Omaha NE',
  '/services/fire-features/': 'fire pits Omaha NE',
  '/services/patios/': 'patio installation Omaha NE',
  '/services/patio-covers/': 'patio covers Omaha NE',
  '/services/custom-outdoor-design/': 'backyard design Omaha NE',
  '/service-areas/omaha-ne/': 'outdoor living Omaha NE',
  '/service-areas/lincoln-ne/': 'outdoor living Lincoln NE',
  '/service-areas/millard-ne/': 'landscaping Millard NE',
  '/service-areas/papillion-ne/': 'outdoor living Papillion NE',
  '/service-areas/la-vista-ne/': 'landscaping La Vista NE',
  '/service-areas/gretna-ne/': 'outdoor living Gretna NE',
  '/service-areas/elkhorn-ne/': 'landscaping Elkhorn NE',
  '/service-areas/bennington-ne/': 'outdoor living Bennington NE',
  '/service-areas/wahoo-ne/': 'landscaping Wahoo NE',
  '/service-areas/ashland-ne/': 'landscaping Ashland NE',
  '/projects/': 'outdoor living projects Omaha NE',
  '/blog/': 'Nebraska outdoor living ideas',
  '/about/': 'about Nebraska Backyard Living',
  '/contact/': 'outdoor living contractor Omaha contact',
  '/get-a-quote/': 'free outdoor living quote Omaha',
  // Blog long-tail targets
  '/blog/how-much-does-a-patio-cost-omaha/': 'patio cost Omaha',
  '/blog/best-patio-materials-nebraska-weather/': 'best patio material Nebraska',
  '/blog/backyard-landscaping-ideas-omaha/': 'landscaping ideas Omaha',
  '/blog/patio-vs-deck-nebraska/': 'patio vs deck Nebraska',
  '/blog/pergola-vs-covered-patio/': 'pergola vs covered patio',
  '/blog/outdoor-kitchen-ideas-nebraska/': 'outdoor kitchen ideas Nebraska',
  '/blog/low-maintenance-backyard-nebraska/': 'low maintenance backyard Nebraska',
  '/blog/retaining-walls-nebraska-property/': 'retaining walls Nebraska',
  '/blog/plan-complete-backyard-transformation/': 'backyard transformation planning',
  '/blog/best-fire-pit-ideas-nebraska/': 'fire pit ideas Nebraska',
  '/blog/choose-right-pavers-patio/': 'how to choose patio pavers',
  '/blog/outdoor-living-trends-nebraska/': 'outdoor living trends Nebraska',
  '/blog/outdoor-living-design-build-what-to-expect/': 'outdoor living design build process',
  '/blog/backyard-outdoor-living-ideas-nebraska/': 'backyard outdoor living ideas Nebraska',
  '/blog/design-backyard-for-entertaining/': 'backyard entertaining design',
};

export const STATIC_SEO = {
  home: {
    title: 'Outdoor Living Omaha, NE | Nebraska Backyard Living',
    description: 'Custom outdoor kitchens, patios, sunrooms, pergolas & fire features for Omaha and Lincoln homeowners. 22+ years, locally owned, A+ BBB. Get a free quote.',
  },
  services: {
    title: 'Outdoor Living Services Omaha & Lincoln, NE | Nebraska Backyard Living',
    description: 'Outdoor kitchens, sunrooms, patios, decks, pergolas, water & fire features — custom designed and built across Omaha & Lincoln, NE. Free consultation.',
  },
  areas: {
    title: 'Service Areas: Omaha, Lincoln & Surrounding NE Communities',
    description: 'Serving Omaha, Lincoln, Millard, Papillion, La Vista, Gretna, Elkhorn, Bennington, Wahoo & Ashland. Free on-site outdoor living consultations.',
  },
  projects: {
    title: 'Outdoor Living Projects Omaha & Lincoln, NE | Our Work',
    description: 'Explore outdoor kitchens, paver patios, pergolas, sunrooms and fire features designed and built by Nebraska Backyard Living across Omaha & Lincoln.',
  },
  about: {
    title: 'About Nebraska Backyard Living | 22+ Years of Craftsmanship',
    description: 'Locally owned Lee Contracting LLC — 22+ years designing and building custom outdoor living spaces across Omaha & Lincoln, Nebraska. A+ BBB rating.',
  },
  blog: {
    title: 'Outdoor Living Blog | Nebraska Patio & Backyard Ideas',
    description: 'Practical guides for Nebraska homeowners: patio costs in Omaha, materials for our climate, outdoor kitchen ideas, and design-build know-how.',
  },
  contact: {
    title: 'Contact Nebraska Backyard Living | Free Consultation',
    description: 'Call (402) 202-9111 or request a free consultation. Custom outdoor living design & build across the Omaha and Lincoln, Nebraska metro areas.',
  },
  quote: {
    title: 'Get a Free Quote | Outdoor Living Omaha & Lincoln, NE',
    description: 'Request your free on-site consultation. Outdoor kitchens, patios, sunrooms & more across Omaha & Lincoln — transparent pricing, no pressure.',
  },
};
